import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const MatchMapContext = createContext<{ params?: Routing.MatchMapParams }>({})

export { MatchMapContext }